import { isSoldOut } from '../../core/rules/stock'
import type { Product } from '../../core/types/catalog'
import type { ShelfPick } from '../../core/types/pages'

/** Zoveel producten op haar plank, ook als er meer gekozen zijn. */
export const SHELF_MAX = 3

/**
 * De keuzes van Sarah die echt te koop zijn: een product dat weg is of uitverkocht valt weg,
 * dubbele keuzes tellen één keer. Puur (getest in aboutRules.test.ts).
 */
export function shelfPicks(picks: readonly ShelfPick[], productById: (id: string) => Product | undefined): { product: Product; why: string }[] {
  const seen = new Set<string>()
  const out: { product: Product; why: string }[] = []
  for (const pick of picks) {
    const product = productById(pick.pickId)
    if (!product || isSoldOut(product) || seen.has(product.id)) continue
    seen.add(product.id)
    out.push({ product, why: pick.why.trim() })
    if (out.length === SHELF_MAX) break
  }
  return out
}
